<template>
    <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
            <template v-slot:default="{ open }">
                <div class="d-flex align-center">
                    <div class="text-subtitle-1 font-weight-bold">Сведения по получателю</div>
                    <v-icon v-if="open">arrow_drop_up</v-icon>
                    <v-icon v-if="!open">arrow_drop_down</v-icon>
                </div>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
            <div>
                <v-row>
                    <v-col cols="4" class="shallowGray--text">{{ contractNumber }}</v-col>
                    <v-col class="black--text">{{ infoCreate.account_number ? infoCreate.account_number : infoCreate.contract_number }}</v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="shallowGray--text">{{ contractName }}</v-col>
                    <v-col class="black--text">{{ infoCreate.consumer_name ? infoCreate.consumer_name : infoCreate.contractor_name }}</v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="shallowGray--text">Адрес</v-col>
                    <v-col class="black--text">{{ infoCreate.address_full_name }}</v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="shallowGray--text">№ установленной пломбы</v-col>
                    <v-col class="black--text">{{ infoCreate.seal_number }}</v-col>
                </v-row>
            </div>
            <div>
                <v-row>
                    <v-col>
                        <v-text-field
                            ref="consumerRepresentativeField"
                            v-model="form.consumer_representative"
                            outlined
                            color="primaryDark"
                            label="Представитель потребителя"
                            validate-on-blur
                            :rules="[validationRules.required]"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-if="isContract">
                        <v-radio-group row v-model="selectJobPosition">
                            <v-radio
                                color="gray"
                                v-for="(jobPositionType, idx) of valueTypes"
                                :key="idx"
                                :label="jobPositionType.label"
                                :value="jobPositionType.value"
                            ></v-radio>
                        </v-radio-group>
                        <v-text-field
                            v-if="selectJobPosition === 'enter'"
                            v-model="form.job_position_type"
                            outlined
                            color="primaryDark"
                            label="Должность "
                            validate-on-blur
                            hide-details
                        />
                        <v-autocomplete
                            v-else
                            v-model="form.job_position_type_rid"
                            outlined
                            color="gray"
                            label="Должность"
                            :items="jobPositionTypes"
                            item-text="job_pos_type_name"
                            item-value="record_id"
                            hide-details
                            clearable
                            :filter="prefixFilter"
                        />
                    </v-col>
                </v-row>
                <v-checkbox v-model="form.abonent_was_not" v-if="isContract" outlined color="gray" label="Абонента не было" />
                <div class="gray--text text-h6 pb-2">Контактный номер телефона</div>
                <div style="color: #666666">Выберите номер телефона из списка контактов по контрагенту или введите вручную</div>
                <v-radio-group row v-model="selectPhoneType">
                    <v-radio color="gray" v-for="(phoneType, idx) of valueTypes" :key="idx" :label="phoneType.label" :value="phoneType.value"></v-radio>
                </v-radio-group>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-if="selectPhoneType === 'enter'"
                            v-maska:[maskaOptions]="phone"
                            v-model="form.telephone_number"
                            hide-details="auto"
                            outlined
                            :rules="[validationRules.phone]"
                            color="primaryDark"
                            placeholder="+7 (XXX) XXX XX XX"
                            label="Контактный номер телефона "
                            validate-on-blur
                        />
                        <v-select
                            :attach="true"
                            v-else
                            hide-details
                            outlined
                            color="primaryDark"
                            label="Выберите контактный номер телефона "
                            v-model="form.telephone_number"
                            :items="infoCreate.contacts"
                            :item-text="isContract ? 'contr_contact_value' : 'account_contact_value'"
                            item-value="contr_contact_value"
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            outlined
                            v-model="form.e_mail"
                            color="primaryDark"
                            validate-on-blur
                            label="E-mail"
                            placeholder="name@gmail.com"
                            :rules="[validationRules.email]"
                        />
                    </v-col>
                </v-row>
                <div class="gray--text text-h6 pb-2">Абонентская задолженность</div>
                <v-radio-group row v-model="abonentDebtModel">
                    <v-radio
                        color="gray"
                        v-for="(abonentDebtType, idx) of abonentDebtTypes"
                        :key="idx"
                        :label="abonentDebtType.label"
                        :value="abonentDebtType.value"
                    ></v-radio>
                </v-radio-group>
                <div v-if="abonentDebtModel" class="pb-6">
                    <div class="text--secondary">Сведения по задолженности:</div>
                    <div class="d-flex" v-for="debt of infoCreate['debt_info']" :key="debt['record_id']">
                        <div class="black--text text--secondary">{{ debt['suppl_service_group_name'] + ':' }}</div>
                        <div class="black--text">{{ debt['sum_debt'] }}</div>
                    </div>
                </div>
                <v-row v-if="abonentDebtModel">
                    <v-col cols="6">
                        <v-text-field
                            outlined
                            v-model.number="form.reconnection_cost"
                            color="primaryDark"
                            label="Стоимость повторного подключения"
                            placeholder="0,00"
                            type="number"
                            :rules="[validationRules.required]"
                        />
                    </v-col>
                </v-row>
            </div>
        </v-expansion-panel-content>
        <v-divider color="gray" />
    </v-expansion-panel>
</template>
<script>
import { validationRules } from '@/utils/validationRules';
import { maskaOptions } from '@/utils';
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';

export default {
    name: 'RecipientInfo',
    props: ['value', 'infoCreate', 'isContract', 'abonentDebt'],
    data: function() {
        return {
            maskaOptions: maskaOptions(this),
            abonentDebtTypes: [
                {
                    value: true,
                    label: 'Оформляется по должнику'
                },
                {
                    value: false,
                    label: 'Оформляется  не по должнику'
                }
            ],
            valueTypes: [
                {
                    value: 'choose',
                    label: 'Выбрать из списка'
                },
                {
                    value: 'enter',
                    label: 'Ввод вручную'
                }
            ],
            phone: {
                masked: '',
                unmasked: '',
                completed: false
            },
            selectPhoneType: 'enter',
            selectJobPosition: 'enter'
        };
    },
    computed: {
        ...mapGetters('refs', ['getJobPositionTypes']),
        validationRules() {
            return validationRules;
        },
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        contractNumber() {
            return this.isContract ? 'Номер договора' : 'Номер лицевого счета';
        },
        contractName() {
            return this.isContract ? 'Контрагент' : 'ФИО собственника';
        },
        abonentDebtModel: {
            get() {
                return this.abonentDebt;
            },
            set(val) {
                this.$emit('update:abonentDebt', val);
            }
        },
        jobPositionTypes() {
            return translate(this.getJobPositionTypes, 'full', this.$i18n.locale);
        }
    },
    watch: {
        selectPhoneType() {
            this.form.telephone_number = null;
        }
    },
    methods: {
        prefixFilter(item, queryText, itemText) {
            if (!queryText) return true;
            return itemText.toLowerCase().startsWith(queryText.toLowerCase());
        }
    }
};
</script>

<style scoped></style>
